import React, { useState, useEffect, useRef } from 'react';
import { CHAIN_IDS, CHAIN_CONNECTIONS } from '../config';
import '../Styles/CustomDropNet.css';


const CustomDropdown = ({ onChange, selectedValue }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Function to get option details from chain ID
  const getOptionDetailsFromChainId = (chainId) => {
    const chainKey = Object.keys(CHAIN_IDS).find(key => CHAIN_IDS[key] === chainId);
    if (!chainKey) {
      console.error(`No chain found for chain ID: ${chainId}`);
      return { label: 'Unknown', value: 'unknown' };
    }
    return { label: CHAIN_CONNECTIONS[chainId].name, value: chainId };
  };

  const [selectedOption, setSelectedOption] = useState(getOptionDetailsFromChainId(selectedValue));

  const handleOptionClick = (label, chainId) => {
    setSelectedOption({ label, value: chainId });
    setIsOpen(false);
    onChange(chainId);
  };

  const handleMouseEnter = () => setIsOpen(true);
  const handleMouseLeave = () => setIsOpen(false);

  // Update selectedOption state when selectedValue prop changes
  useEffect(() => {
    setSelectedOption(getOptionDetailsFromChainId(selectedValue));
  }, [selectedValue]);

  return (
    <div className="mr-5 inline-block">
      <div className="relative inline-block text-left" ref={dropdownRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <div>
          <button
            type="button"
            className='secondary-button'
            onClick={() => setIsOpen(!isOpen)}
          >
            {selectedOption.label}
          </button>
        </div>

        {isOpen && (
          <div className="custom-dropdown-style">
            <div
              className="py-1 rounded-md bg-white shadow-xs"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
            >
              {Object.values(CHAIN_IDS).map(chainId => {
                const chainData = CHAIN_CONNECTIONS[chainId];
                if (!chainData) {
                  console.warn(`No data found for chain ID: ${chainId}`);
                  return null;  // Return null for React to skip rendering this item
                }
                return (
                  <button
                    key={chainId}
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                    role="menuitem"
                    onClick={() => handleOptionClick(chainData.name, chainId)}
                  >
                    {chainData.name}
                  </button>
                );
              })}

            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomDropdown;